import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RoleService {
    //TODO: cambiar por el archivo en el que van a estar los permisos
    private userPermissions: string[] = ['listLessons'];
    private currentRole: string = '';

    constructor() {}

    getRole(): string {
        return this.currentRole;
    }

    setRole(role: string): void {
        this.currentRole = role;
    }

    hasPermission(requiredPermissions: string[]): Observable<boolean> {
        const hasAllPermissions = requiredPermissions.every(permission =>
        this.userPermissions.includes(permission)
        );
        return of(hasAllPermissions);
    }

    getHomeRouteForGroup(group?: string): string {
        switch (group) {
            case 'SUPER': return '/super/dashboard';
            case 'TEACHER': return '/teacher/lessons';
            case 'STUDENT': return '/student';
            case 'EVALUATOR': return '/metrics';
            case 'ADMINISTRATOR':
            case 'MANAGER': return '/lessons';
            default: return '/login';
        }
    }
}